"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeDnFromParts = exports.makeDn = exports.parentDn = exports.parseDn = exports.getKind = exports.parseRn = exports.splitDn = void 0;

var the_lodash_1 = __importDefault(require("the-lodash"));

function splitDn(dn) {
  var parts = [];
  var ch = null;
  var token = "";
  var parsingKind = true;
  var parsingNaming = true;

  for (var i = 0; i < dn.length; i++) {
    var skipAdd = false;
    ch = dn.charAt(i);

    if (parsingKind) {
      if (ch == '-') {
        parsingKind = false;
      } else if (ch == '/') {
        skipAdd = true;
        parts.push(token);
        token = "";
      }
    } else {
      if (parsingNaming) {
        if (ch == ']') {
          parsingNaming = false;
        }
      } else {
        if (ch == '[') {
          parsingNaming = true;
        } else if (ch == '/') {
          skipAdd = true;
          parts.push(token);
          token = "";
        }
      }
    }

    if (!skipAdd) {
      token += ch;
    }
  }

  if (token.length > 0) {
    parts.push(token);
  }

  return parts;
}

exports.splitDn = splitDn;

function parseRn(rn) {
  var index = rn.indexOf('-');

  if (index == -1) {
    return {
      rn: rn,
      kind: getKind(rn),
      name: null
    };
  }

  return {
    rn: rn,
    kind: getKind(rn.substr(0, index)),
    name: rn.substr(index + 2, rn.length - (index + 3))
  };
}

exports.parseRn = parseRn;

function getKind(kind) {
  return kind;
}

exports.getKind = getKind;

function parseDn(dn) {
  var parts = splitDn(dn);
  return parts.map(function (x) {
    return parseRn(x);
  });
}

exports.parseDn = parseDn;

function parentDn(dn) {
  var parts = splitDn(dn);
  return makeDnFromParts(the_lodash_1.default.dropRight(parts));
}

exports.parentDn = parentDn;

function makeDn(parentDn, childRn) {
  if (!parentDn) {
    return childRn;
  }

  return parentDn + "/" + childRn;
}

exports.makeDn = makeDn;

function makeDnFromParts(parts) {
  return parts.join('/');
}

exports.makeDnFromParts = makeDnFromParts;